export const reportsList = [
    {
        id: 'clientsConversion',
        name: 'Client Conversion Log',
        hasDateRange: false,
        packageName: 'Epic-Client.dtsx',
    },
    {
        id: 'policiesConversion',
        name: 'Policy Conversion Log',
        hasDateRange: false,
        packageName: 'Epic-Policy.dtsx',
    },
    {
        id: 'linesOfBusinessConversion',
        name: 'Line of Business Conversion Log',
        hasDateRange: false,
        packageName: 'Epic-LOB.dtsx',
    },
    {
        id: 'employeesConversion',
        name: 'Employee Conversion Log',
        hasDateRange: false,
        packageName: 'Epic-Employee.dtsx',
    },
    {
        id: 'claimsConversion',
        name: 'Claim Conversion Log',
        hasDateRange: false,
        packageName: 'Epic-Claim.dtsx',
    },
    {
        id: 'clientImageReport',
        name: 'Client Image Log',
        hasDateRange: false,
        packageName: '00-00-00-00-Tier-Proc-All.dtsx',
    },
    {
        id: 'brokerImageReport',
        name: 'Broker Image Log',
        hasDateRange: false,
        packageName: '00-00-00-00-Tier-Proc-All.dtsx',
    },
    {
        id: 'employeeImageReport',
        name: 'Employee Image Log',
        hasDateRange: false,
        packageName: '00-00-00-00-Tier-Proc-All.dtsx',
    },
    {
        id: 'companyImageReport',
        name: 'Company Image Log',
        hasDateRange: false,
        packageName: '00-00-00-00-Tier-Proc-All.dtsx',
    },
    {
        id: 'vendorImageReport',
        name: 'Vendor Image Log',
        hasDateRange: false,
        packageName: '00-00-00-00-Tier-Proc-All.dtsx',
    },
    {
        id: 'financeImageReport',
        name: 'Finance Image Log',
        hasDateRange: false,
        packageName: '00-00-00-00-Tier-Proc-All.dtsx',
    },
    {
        id: 'otherImageReport',
        name: 'Other Image Log',
        hasDateRange: false,
        packageName: '00-00-00-00-Tier-Proc-All.dtsx',
    },
    {
        id: 'missingImagesConversion',
        name: 'Missing & Compressed Images',
        hasDateRange: false,
        packageName: 'Epic-MissingImages.dtsx',
    },
    {
        id: 'worksmartClientImages',
        name: 'WorkSmart Client Images',
        hasDateRange: false,
        packageName: 'Epic-WorkSmart_ClientImages.dtsx',
    },
    {
        id: 'inconsistentPackages',
        name: 'Inconsistent Packages',
        hasDataRange: false,
        packageName: 'Epic-InconsistentPackages.dtsx',
    },
    {
        id: 'employeesMissingRoles',
        name: 'Employees Missing Roles',
        hasDataRange: false,
        packageName: 'Epic-EmployeesMissingRoles.dtsx',
    },
    {
        id: 'codeCounts',
        name: 'Code Counts Report',
        hasDateRange: false,
        packageName: 'Epic-CodeCounts.dtsx',
    },
    {
        id: 'runtimeStatistics',
        name: 'Runtime Statistics',
        hasDateRange: false,
        packageName: 'Epic-RuntimeStatistics.dtsx',
    },
    {
        id: 'copyMapCompanyValidation',
        name: 'Copy Mapping Company Validation Errors',
        hasDateRange: false,
        packageName: '',
    },
]


export const mergeReportsList = [
    {
        id: 'clientsConversion',
        name: 'Client Conversion Log',
        hasDateRange: false,
        packageName:''
    },
    {
        id: 'policiesConversion',
        name: 'Policy Conversion Log',
        hasDateRange: false,
        packageName: ''
    },
    {
        id: 'linesOfBusinessConversion',
        name: 'Line of Business Conversion Log',
        hasDateRange: false,
        packageName: ''
    },
    {
        id: 'employeesConversion',
        name: 'Employee Conversion Log',
        hasDateRange: false,
        packageName: ''
    },
    {
        id: 'claimsConversion',
        name: 'Claim Conversion Log',
        hasDateRange: false,
        packageName: ''
    },
    {
        id: 'codeCounts',
        name: 'Code Counts Report',
        hasDateRange: false,
        packageName: ''
    },
    {
        id: 'runtimeStatistics',
        name: 'Runtime Statistics',
        hasDateRange: false,
        packageName: ''
    },
]

export const ndtReportsList = [
    {
        id: 'clientsConversion',
        name: 'Client Conversion Log',
        hasDateRange: false,
        packageName: ''
    },
    {
        id: 'policiesConversion',
        name: 'Policy Conversion Log',
        hasDateRange: false,
        packageName: ''
    },
    {
        id: 'linesOfBusinessConversion',
        name: 'Line of Business Conversion Log',
        hasDateRange: false,
        packageName: ''
    },
    {
        id: 'employeesConversion',
        name: 'Employee Conversion Log',
        hasDateRange: false,
        packageName: ''
    },
    {
        id: 'claimsConversion',
        name: 'Claim Conversion Log',
        hasDateRange: false,
        packageName: ''
    },
    {
        id: 'codeCounts',
        name: 'Code Counts Report',
        hasDateRange: false,
        packageName: ''
    },
    {
        id: 'runtimeStatistics',
        name: 'Runtime Statistics',
        hasDateRange: false,
        packageName: ''
    },
    {
        id: 'rollbackConversion',
        name: 'Rollback Conversion Log',
        hasDateRange: false,
        packageName: ''
    },
]

export const miniReportsList = [
    {
        id: 'DIUCustomersValidation',
        name: 'Customers Validation',
        hasDateRange: false,
        packageName: ''
    },
    {
        id: 'DIUCustomersConversion',
        name: 'Customers Post Conversion Log',
        hasDateRange: false,
        packageName: ''
    },
    {
        id: 'DIUPoliciesValidation',
        name: 'Policies Validation',
        hasDateRange: false,
        packageName: ''
    },
    {
        id: 'DIUPoliciesConversion',
        name: 'Policies Post Conversion Log',
        hasDateRange: false,
        packageName: ''
    },
    {
        id: 'DIUContactsValidation',
        name: 'Contacts Validation',
        hasDateRange: false,
        packageName: ''
    },
    {
        id: 'DIUContactsConversion',
        name: 'Contacts Post Conversion Log',
        hasDateRange: false,
        packageName: ''
    },
    {
        id: 'DIUActivitiesValidation',
        name: 'Activities Validation',
        hasDateRange: false,
        packageName: ''
    },
    {
        id: 'DIUActivitiesConversion',
        name: 'Activities Post Conversion Log',
        hasDateRange: false,
        packageName: ''
    },
]